import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'

import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import Loading from '../../components/Loading';
import NumberFormat from '../../components/NumberFormat';
import AddPrivilege from './AddPrivilege';
import ActionButton from '../../components/ActionButton';
import Swal from 'sweetalert2';



const Privileges = () => {
    const [errors, setErrors] = useState(null);

    const [loading, setLoading] = useState(false);
    const [privileges, setPrivileges] = useState([]);
    const [showAddPrivilege, setShowAddPrivilege] = useState(false);
  
    
    const { token, setToken, user } = useStateContext();
    
    const tableRef = useRef();
   
    const navigate = useNavigate();

    const supprimer = (privilege) => {
        Swal.fire({
            title: "Confirmation",
            text: "Etes vous sûre de supprimer cette element ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2196F3",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui!",
            cancelButtonText: "Non!"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosClient.delete('/privilege/' + privilege.id)
                    .then(response => {
                        toast.success('Opération effectuée avec succès!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        getPrivileges();
                    }).catch(err => {
                        const response = err.response;
                        if (response.status === 401) {
                            setToken(null);
                        }
                        else {
                            if (response.status === 422) {
                                setErrors(response.data.errors);
                                setLoading(false);
                                toast.error('Une Erreur est survenue', {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                    theme: "light",
                                });
                            } else {
                                if (response.status === 403) {
                                    navigate('/403');
                                } else {
                                    if (response.status === 404) {
                                        navigate('/404');
                                    }
                                    else {
                                        navigate('/500');
                                    }
                                }
                            }
        
                        }
                    })
            }
        });
    }

    useEffect(() => {
        getPrivileges()
    }, [])

    
    const closeAddPrivilege = () => {
        setShowAddPrivilege(false);
    }

    
    
    
    const getPrivileges = () => {
        setLoading(true);
        axiosClient.get('/privileges')
            .then(response => {
                setPrivileges(response.data.privileges);
                setLoading(false);
                setErrors(null);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }


    return (
        <>
            <Header title="Privileges" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            
            <div className="flex my-4">
                    <Button onClick={() => setShowAddPrivilege(true)} color="bg-blue-500" icon={<BsPlusCircleFill />} size="20" text="Ajouter" textColor="text-white" />
                </div>
                    
            
            <div className='flex mt-3 overflow-auto'>
                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>Utilisateur Sup</th>
                            <th>Utilisateur Inf</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="6"><Loading /></td></tr></tbody> :
                        <tbody>
                            {privileges.map(o => (
                                <tr>
                                    <td>{o.userTop.nom}</td>
                                    <td>{o.userDown.nom}</td>
                                    <td>{o.type}</td>
                                    <td>
                                        <div className="flex gap-2">
                                            <ActionButton onClick={() => { supprimer(o) }} color="bg-red-500" icon={<BsTrash />} textColor="text-white" title="Supprimer" /> 
                                        </div>
                                    </td>
                                </tr>
                            ))

                            }
                        </tbody>
                    }

                </table>
            </div>
            {
                showAddPrivilege ? <AddPrivilege onClose={closeAddPrivilege} /> : <></>
            }
        </>
    )
}

export default Privileges